import Vue from 'vue'
import Router from 'vue-router'
import membersArea from '@/page/membersArea'
import myCard from '@/page/myCard'
import shopDetail from '@/page/shopDetail'
import cardInfo from '@/page/cardInfo'
import orderDetail from '@/page/orderDetail'
import zfSuccess from '@/page/zfSuccess'
import zfErr from '@/page/zfErr'
Vue.use(Router)

export default new Router({
    routes: [
        //会员专区
        {
            path: '/',
            name: 'membersArea',
            component: membersArea
        },
        //我的卡券
        {
            path: '/myCard',
            name: 'myCard',
            component: myCard
        },
        //商品详情
        {
            path: '/shopDetail',
            name: 'shopDetail',
            component: shopDetail
        },
        //卡券详情
        {
            path: '/cardInfo',
            name: 'cardInfo',
            component: cardInfo
        },
        //支付成功
        {
            path: '/zfSuccess',
            name: 'zfSuccess',
            component: zfSuccess
        },
        //支付失败
        {
            path: '/zfErr',
            name: 'zfErr',
            component: zfErr
        },
        //订单详情
        {
            path: '/orderDetail',
            name: 'orderDetail',
            component: orderDetail
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js